import React, { useRef, useState } from 'react';
import { uploadBanner } from '../services/api';
import toast from 'react-hot-toast';
import './BannerUpload.css';

export default function BannerUpload({ currentUrl, onUpload }) {
  const inputRef  = useRef(null);
  const [preview, setPreview] = useState(currentUrl || null);
  const [loading, setLoading] = useState(false);

  const handleFile = async (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => setPreview(e.target.result);
    reader.readAsDataURL(file);

    setLoading(true);
    try {
      const fd = new FormData();
      fd.append('banner', file);
      const res = await uploadBanner(fd);
      setPreview(res.data.url);
      onUpload?.(res.data.url);
      toast.success('✅ تم تحديث صورة الغلاف!');
    } catch (err) {
      setPreview(currentUrl || null);
      toast.error(err.response?.data?.error || 'فشل رفع صورة الغلاف');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="banner-upload" onClick={() => !loading && inputRef.current?.click()}>
      {preview
        ? <img src={preview} alt="banner" className="bu-preview" />
        : <div className="bu-placeholder"><span>🖼️</span><p>اضغط لإضافة صورة غلاف</p><p className="bu-hint">1200×300 — JPG أو PNG</p></div>}
      {loading && <div className="bu-loading"><div className="spinner" /></div>}
      <div className="bu-overlay"><span>📷 تغيير الغلاف</span></div>
      <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp"
        style={{ display:'none' }} onChange={e => { if (e.target.files[0]) handleFile(e.target.files[0]); }} />
    </div>
  );
}
